__turbopack_context__.v({
  "callout": "wO8E1G_callout",
  "calloutTitle": "wO8E1G_calloutTitle",
});
